import { mix } from "@chorda/core";
export const Action = (props) => {
    return mix({
        tag: 'a',
        css: 'is-action',
        templates: {
            icon: {
                // Icon
                weight: -10,
                css: 'is-before'
            },
            content: {
                tag: 'span'
            }
        }
    }, {
        css: props.css,
        events: {
            $dom: {
                click: props.onClick
            }
        },
        templates: {
            icon: {
                css: props.icon
            }
        }
    });
};
